// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__85V-l","placeholdersHeader":"styles_placeholdersHeader__3CIzQ","editorStyle":"styles_editorStyle__3qt9p","placeholdersBox":"styles_placeholdersBox__962zW"};